"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.App = void 0;
const react_1 = __importStar(require("react"));
const react_tooltip_1 = __importDefault(require("react-tooltip"));
const config_1 = require("../../config");
const GitHubCorner_1 = require("./GitHubCorner");
const RuleTable_1 = require("./RuleTable");
const LanguageSwitch_1 = require("./LanguageSwitch");
const utils_1 = require("../utils");
const App = () => {
    const query = (0, utils_1.getQuery)();
    const [namespace, setNamespace] = (0, react_1.useState)((0, utils_1.defaultTo)(query.rule, config_1.NAMESPACES[0], config_1.NAMESPACES));
    const [hideOff, toggleHideOff] = (0, react_1.useState)(query.hideOff === '1');
    const language = (0, utils_1.getLanguage)();
    (0, react_1.useEffect)(() => {
        document.documentElement.lang = language;
    }, []);
    (0, react_1.useEffect)(() => {
        react_tooltip_1.default.rebuild();
    }, [namespace]);
    const Header = (react_1.default.createElement("div", { className: "flex-center" },
        react_1.default.createElement("div", { className: "container-fluid" },
            react_1.default.createElement("h1", { className: "site-title" }, "eslint-config-alloy"),
            react_1.default.createElement(LanguageSwitch_1.LanguageSwitch, { language: language }),
            react_1.default.createElement("form", { className: "top-gap site-form" },
                react_1.default.createElement("select", { value: namespace, onChange: (e) => {
                        setNamespace(e.target.value);
                        (0, utils_1.replaceUrl)((0, utils_1.newUrl)({ query: { rule: e.target.value } }));
                    } }, config_1.NAMESPACES.map((namespace) => (react_1.default.createElement("option", { key: namespace, value: namespace }, namespace)))),
                react_1.default.createElement("label", null,
                    react_1.default.createElement("input", { type: "checkbox", checked: hideOff, onChange: (e) => {
                            toggleHideOff(e.target.checked);
                            (0, utils_1.replaceUrl)((0, utils_1.newUrl)({ query: { hideOff: e.target.checked } }));
                        } }),
                    (0, utils_1.t)('隐藏已禁用的规则'))))));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(GitHubCorner_1.GitHubCorner, { href: "https://github.com/AlloyTeam/eslint-config-alloy" }),
        Header,
        react_1.default.createElement(RuleTable_1.RuleTable, { namespace: namespace, hideOff: hideOff }),
        react_1.default.createElement(react_tooltip_1.default, { className: "site-react-tooltip", place: "top", type: "error", effect: "solid", delayHide: 100, html: true })));
};
exports.App = App;
